export const defaultDepartments = [
  {
    label: "Body Shop",
    value: "BODY_SHOP"
  },
  {
    label: "Parts",
    value: "PARTS"
  },
  {
    label: "Employment",
    value: "EMPLOYMENT"
  },
  {
    label: "Rental",
    value: "RENTAL"
  },
  {
    label: "Financing",
    value: "FINANCING"
  },
  {
    label: "Staff",
    value: "STAFF"
  },
  {
    label: "New Inventory",
    value: "NEW_INVENTORY"
  },
  {
    label: "Sales",
    value: "SALES"
  },
  {
    label: "Pre-Owned Inventory",
    value: "PRE-OWNED_INVENTORY"
  },
  {
    label: "Service",
    value: "SERVICE"
  }
];
